export default function Unauthorized() {
  return (
    <div style={{ textAlign: "center", marginTop: 80 }}>
      <h1>🚫 Access Denied</h1>
      <p>You do not have permission to access this page.</p>
    </div>
  );
}
